/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ShareModal.css';

const ShareModal = ({ isOpen, setIsOpen, children }) => {
  const [portalElement, setPortalElement] = useState(null);

  useEffect(() => {
    let element = document.getElementById('modal-root');
    if (!element) {
      element = document.createElement('div');
      element.id = 'modal-root';
      document.body.appendChild(element);
    }
    setPortalElement(element);

    // return () => {
    //   if (element && element.childNodes.length === 0) {
    //     document.body.removeChild(element);
    //   }
    // };
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [isOpen]);

  if (!portalElement) return null;

  return ReactDOM.createPortal(
    <>
      <div
        className={`modal-overlay ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(false)}
      >
        <div
          className={`modal-content ${isOpen ? 'active' : ''}`}
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-header">
            <button className="close-button" onClick={() => setIsOpen(false)}>
              ×
            </button>
            <h2>Share Ticket</h2>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </>,
    portalElement
  );
};

export default ShareModal;
